import { render, staticRenderFns } from "./CollectionListCallCenter.vue?vue&type=template&id=5c02675c&"
import script from "./CollectionListCallCenter.vue?vue&type=script&lang=js&"
export * from "./CollectionListCallCenter.vue?vue&type=script&lang=js&"
import style0 from "./CollectionListCallCenter.vue?vue&type=style&index=0&id=5c02675c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports